export enum NewNodeTypes {
  CHILD = 'child',
  SIBLING = 'sibling'
}
